export const getLocaleString = (
  input: number,
  language: string,
  fractionDigits = 0,
): string => {
  return input.toLocaleString(language, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

function computeBounds(
  lower: number | null | undefined,
  upper: number | null | undefined,
  fallbackBase: number,
  lowerLimitRate: number,
  higherLimitRate: number,
  scale: number,
): [number, number] {
  return [
    (lower ?? lowerLimitRate * fallbackBase) * scale,
    (upper ?? higherLimitRate * fallbackBase) * scale,
  ];
}

export const formatCountRange = (
  lower: number | null | undefined,
  upper: number | null | undefined,
  fallbackBase: number,
  lowerLimitRate: number,
  higherLimitRate: number,
  language: string,
): string => {
  const [lo, hi] = computeBounds(
    lower,
    upper,
    fallbackBase,
    lowerLimitRate,
    higherLimitRate,
    1,
  );
  return `${getLocaleString(lo, language)} - ${getLocaleString(hi, language)}`;
};

export const formatTonnesRange = (
  lower: number | null | undefined,
  upper: number | null | undefined,
  fallbackBase: number,
  lowerLimitRate: number,
  higherLimitRate: number,
  language: string,
  scale: number,
): string => {
  const [lo, hi] = computeBounds(
    lower,
    upper,
    fallbackBase,
    lowerLimitRate,
    higherLimitRate,
    scale,
  );
  return `${getLocaleString(lo, language, 2)} - ${getLocaleString(hi, language, 2)}`;
};
